export default __webpack_public_path__ + "static/media/development_mobile.79086199.jpg";